import { render, staticRenderFns } from "./FoxInput.vue?vue&type=template&id=572f4376&scoped=true&"
import script from "./FoxInput.vue?vue&type=script&lang=js&"
export * from "./FoxInput.vue?vue&type=script&lang=js&"
import style0 from "./FoxInput.vue?vue&type=style&index=0&id=572f4376&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572f4376",
  null
  
)

export default component.exports